
import React, { useState } from 'react';

function MobileApp() {
 const [activeAccordion, setActiveAccordion] = useState('collapseOne');

  const toggleAccordion = (id) => {
    setActiveAccordion(activeAccordion === id ? '' : id);
  };

  return (
    <>
      {/* Hero Area */}
      <div 
        className="inner-page-hero-area" 
        style={{
          backgroundImage: 'url(assets/img/all-images/bg/hero-bg1.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
      >
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="inner-header text-center heading1">
                <h1>Mobile App Development</h1>
                <div className="space28"></div>
                <a href="/">
                  Home <i className="fa-solid fa-angle-right"></i> 
                  <span>Mobile App Development</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Service Sidebar Area */}
      <div className="service-sidebar-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="service2-widget-sidebar" style={{padding: '0 !important'}}>
                <div className="img1 reveal image-anime">
                  <img src="assets/img/all-images/service/service-img2.png" alt="" />
                </div>
                <div className="space32"></div>
                <h3>Mobile App Development</h3>
                <div className="space20"></div>
                <p>
                  Mobile application development is one of the most exciting and growing fields in the tech industry today. With so many people using mobile devices to access the internet, there’s never been a better time to develop a mobile app.
                </p>
                <div className="space14"></div>
                
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Custom iOS & Android Development</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                       <b>Engaging UI/UX Design</b>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <ul className="list">
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Cross-Platform App Solutions</b>
                      </li>
                      <li>
                        <img src="assets/img/icons/check1.svg" alt="" />
                        <b>Scalable & Secure Architecture</b>
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div className="space32"></div>
                <div className="pera-box">
                  {/* <h4>Safeguard Your Business With Advanced Cybersecurity</h4> */}
                  <div className="space12"></div>
                  <p>
                   If you’re looking for a way to increase your business’ reach, consider developing a mobile application. There’s a growing trend of people using mobile apps to access information and services, and businesses that don’t have mobile applications are at a disadvantage. Not only that, but mobile apps are a great way to keep customers engaged and attached to your business. By developing a mobile application, you can provide your customers with convenient access to your products and services wherever they are. And since most people use their smartphones more than their laptops or desktops, developing a mobile app is a great way to reach more people.
                  </p>
                </div>
                
                <div className="space18"></div>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img3.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="space30"></div>
                    <div className="img1 reveal image-anime">
                      <img src="assets/img/all-images/service/service-img4.png" alt="" />
                    </div>
                  </div>
                </div>
                
                <div className="space32"></div>
                <h3>What We Provide</h3>
<div class="space20"></div>
<ul className="check-list">
  <li>
    There are a variety of different mobile app development platforms to choose from, and each has its own strengths and weaknesses.
  </li>
  <li>
    iOS apps are usually more user-friendly and sophisticated than Android apps.
  </li>
  <li>
    Android apps are often more versatile and can be used to create applications that run on a wider range of devices, including smart TVs and vehicles.
  </li>
  <li>
    Regardless of which platform you choose, we’ll help you select the right one and develop your app to meet your specific needs.
  </li>
  <li>
    If you follow our tips, you’ll have a successful business.
  </li>
</ul>


                
                <div className="space48"></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileApp
